export default __webpack_public_path__ + "static/media/tuffHammerPics8.205cbd22.jpeg";